import React from 'react';
import styles from './ItemListViewN.scss';
import classNames from 'classnames/bind';

import {NumericFormat} from 'react-number-format';

import {Link} from 'react-router-dom';

// import Adsense23055 from 'components/adsense/Adsense23055';

const cx = classNames.bind(styles);

const ItemObject = ({
  itemKind, item_nm, dmg, dfs, con, cri, size, speed, img_src, tier, item_dtl_dv, illegal,
  dot, stm, run, mag, wei, pot, onClickItemDtl, itemSeq, key
}) => {
  return (
    <Link to={`/item/${itemSeq}`} key={key}>
      <div className={cx('card')}>
        <img src={img_src} alt={item_nm} />
        <div className={('card-body')}>
          <div className={('card-subtitle')}>
            {`${tier}등급 ${illegal === 'Y' ? '불법' : ''}`}
            {
              itemKind === '01' || itemKind === '02' ? (
                item_dtl_dv === '샷건' && speed >= 240 ? '연사샷건' 
                : item_nm.indexOf('Anti') > -1 || item_nm.indexOf('Fennec') > -1 ? '안탱'
                : item_nm.indexOf('HEAT') > -1 ? '유탄'
                : item_dtl_dv ==='중화기' && speed >= 300 ? '화방'
                : item_dtl_dv ==='중화기' && speed < 300 ? '대전'
                : item_dtl_dv
              ) : item_dtl_dv
            }
          </div>
          <div className={('card-title')}>{item_nm}</div>
          <div className={('card-text')}>
            { 
              dmg !== '0' ? (
                itemKind === '01' || itemKind === '02' ? 
                '파괴력:' : '공격력:'
              ) : ''
            }
            {dmg !== '0' ?
            <span className={cx('damage')}>
              <NumericFormat 
                value={dmg} displayType={'text'} 
                thousandSeparator={true} 
                suffix={itemKind === '05' || itemKind === '06' ? '%' : ''}
              />
            </span>
            : ''}
            {dfs !== '0' && item_dtl_dv.indexOf('가발') === -1 ?
            <>
            방어력: 
            <span className={cx('defense')}>
              <NumericFormat 
                value={dfs} displayType={'text'} 
                thousandSeparator={true}
                suffix={itemKind === '06' && item_dtl_dv !== '토이' ? '%' : ''}
              />
            </span>
            </>
            : ''}
            {con !== '0' ?
            <>
            체력: 
            <span className={cx('option-con')}>
              <NumericFormat 
                value={con} displayType={'text'} 
                thousandSeparator={true} 
                suffix={''}
              />
            </span>
            </>
            : ''}
            {cri !== '0' ?
            <>
            치명:
            <span className={cx('crit')}>
              <NumericFormat 
                value={cri} displayType={'text'} 
                thousandSeparator={true}
                suffix={''}
              />
            </span>
            </>
            : ''}
            {dot !== '0' ?
            <>회피:
            <span className={cx('option-dot')}>
              <NumericFormat 
                value={dot} displayType={'text'} 
                thousandSeparator={true}
                suffix={''}
              />
            </span>
            </>
            : ''}
            {stm !== '0' ?
            <>지구:
            <span className={cx('option-stm')}>
              <NumericFormat 
                value={stm} displayType={'text'} 
                thousandSeparator={true}
                suffix={''}
              />
            </span></>
            : ''}
            {run !== '0' ?
            <>속도:
            <span className={cx('option-run')}>
              <NumericFormat 
                value={run} displayType={'text'} 
                thousandSeparator={true}
                suffix={''}
              />
            </span></>
            : ''}
            {mag !== '0' ?
            <>행동:
            <span className={cx('option-mag')}>
              <NumericFormat 
                value={mag} displayType={'text'} 
                thousandSeparator={true}
                suffix={''}
              />
            </span></>
            : ''}
            {wei !== '0' ?
            <>무감:
            <span className={cx('option-wei')}>
              <NumericFormat 
                value={'-'+wei} displayType={'text'} 
                thousandSeparator={true}
                suffix={''}
              />
            </span></>
            : ''}
            {pot !== '0' ? 
            <>탄착:
            <span className={cx('option-pot')}>
              <NumericFormat 
                value={pot} displayType={'text'} 
                thousandSeparator={true}
                suffix={''}
              />
            </span></>
            : ''}
            {
              itemKind === '01' || itemKind === '02' ? `${size} ${speed}/1분` : ''
            }
          </div>
        </div>
      </div>
    </Link>
  )
}

const ItemListView = ({
  loading 
  // ,itemList 
  ,itemListFiltering
  ,itemFilters
  ,onChangeItemSort
  ,onClickItemDtl
}) => {

  const {itemKind,/* clyn, illegal, tier, itemDtlDv01, itemDtlDv02, itemKindMap, */sortKind, filterText} = itemFilters;
  const totalCnt = filterText === '' ? itemListFiltering.length : itemListFiltering.length;
  const curItemList = filterText === '' ? itemListFiltering : itemListFiltering;

  const list = curItemList.sort((a, b) => {
    const aValue = sortKind === '1' ? Number(a.DMG) : sortKind === '2' ? Number(a.DFS) :
    sortKind === '3' ? a.ITEM_NM.indexOf('[CL] ') > -1 ? a.ITEM_NM.substring(5) : 
    a.ITEM_NM : a.ITEM_SEQ;

    const bValue = sortKind === '1' ? Number(b.DMG) : sortKind === '2' ? Number(b.DFS) :
    sortKind === '3' ? b.ITEM_NM.indexOf('[CL] ') > -1 ? b.ITEM_NM.substring(5) : 
    b.ITEM_NM : b.ITEM_SEQ;
    
    if(sortKind === '0') {
      return 0;
    }else if(sortKind === '1' || sortKind === '2') {
      if(aValue > bValue) return -1; //역순
    }else{
      if (aValue > bValue) {
        return 1;
      }
      if (aValue < bValue) {
        return -1;
      }
      return 0;
    }

    return 0;
  }).filter((item) => {
    return item.ITEM_NM.toLowerCase().indexOf(filterText.toLowerCase()) > -1;
  }).map((item, cnt) => {
    const {
      ITEM_NM, DMG, DFS, CON, CRI, SIZE, SPEED, IMG_SRC, ITEM_SEQ, TIER, 
      ITEM_DTL_DV, ILLEGAL, DOT, STM, RUN, MAG, WEI, POT
    } = item;

    return cnt % 7 === 0 ? 
    <>
    {/* <Adsense23055/>  */}
    <ItemObject 
    // onClick={onClickItemDtl}
    itemKind={itemKind}
    item_nm={ITEM_NM}
    dmg={DMG}
    dfs={DFS}
    con={CON}
    cri={CRI}
    size={SIZE}
    speed={SPEED}
    img_src={IMG_SRC}
    tier={TIER}
    item_dtl_dv={ITEM_DTL_DV}
    illegal={ILLEGAL}
    dot={DOT}
    stm={STM}
    run={RUN}
    mag={MAG}
    wei={WEI}
    pot={POT}
    itemSeq={ITEM_SEQ}
    key={cnt}
    onClickItemDtl={onClickItemDtl}
    />
    </>
    :
    <ItemObject 
    // onClick={onClickItemDtl}
    itemKind={itemKind}
    item_nm={ITEM_NM}
    dmg={DMG}
    dfs={DFS}
    con={CON}
    cri={CRI}
    size={SIZE}
    speed={SPEED}
    img_src={IMG_SRC}
    tier={TIER}
    item_dtl_dv={ITEM_DTL_DV}
    illegal={ILLEGAL}
    dot={DOT}
    stm={STM}
    run={RUN}
    mag={MAG}
    wei={WEI}
    pot={POT}
    itemSeq={ITEM_SEQ}
    key={cnt}
    onClickItemDtl={onClickItemDtl}
    />
  });
  // const list2 = curItemList.filter((v,c) => {
  //   return (v.CTYPE === '1') && (v.STYPE1 === '2') && (v.TIER === '6') && (v.CLYN === 'Y')  
  //    ;
  // });
  // console.log(JSON.stringify(curItemList.sort((a,b) => {
  //   return Number(a.TIER) < Number(b.TIER) ? -1 : 1;
  // })));
  // console.log(JSON.stringify(curItemList));

  // const itemDtlDv = itemFilters[`itemDtlDv${itemKind}`];
  
  // const kindTitle = `${itemKindMap[`itemKind${itemKind}`].name}`;
  // let decTxt = `#${kindTitle}`;
  // decTxt += clyn.map(ele => `#${ele === 'Y' ? 'CL' : 'NonCL'}`).join('');
  // decTxt += illegal.map(ele => `#${ele === 'Y' ? '불법' : '합법'}`).join('');
  // decTxt += tier.map(ele => `#${ele}등급`).join('');
  // decTxt += itemDtlDv.map(ele => `#${ele}`).join('');
  const style={
    marginBottom: '20px'
  }

  return (
    <>
      <div className={cx('button-group')} style={style}>
        <span>{totalCnt} Items</span>
        {itemKind !== '03' && itemKind !== '04' ? 
        <>
        <input type="radio" name="itemSort" onChange={onChangeItemSort} 
        value="1" id="itemSort_radio01" checked={sortKind==='1'}/>
        <label htmlFor="itemSort_radio01">
          공격력높은순
        </label>
        </>
        : ''}
        {itemKind !== '01' && itemKind !== '02' ? 
        <>
          <input type="radio" name="itemSort" onChange={onChangeItemSort} 
          value="2" id="itemSort_radio02" checked={sortKind==='2'}/>
          <label htmlFor="itemSort_radio02">
            방어력높은순
          </label>
        </>
        : ''}
        <>
          <input type="radio" name="itemSort" onChange={onChangeItemSort} 
          value="3" id="itemSort_radio03" checked={sortKind==='3'}/>
          <label htmlFor="itemSort_radio03">
            이름순
          </label>
        </>
        <>
          <input type="radio" name="itemSort" onChange={onChangeItemSort} 
            value="0" id="itemSort_radio04" checked={sortKind==='0'}/>
          <label htmlFor="itemSort_radio04">
            정렬원래대로
          </label>
        </>
      </div>

      <div className={cx('grid')}>{list}</div>
    </>
  );
}

export default ItemListView;